import { memo, useContext, useState } from "react";
import Button from "../components/button/button";
import Input from "../components/input/input";
import styles from './support.module.css'
import Popup from "../components/popup/popup";
import success from '../icons/success.svg'
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../Context/Context";
import { sendSupportMsg } from "../services/api";

export default memo(function Support() {
    const { user } = useContext(UserDataContext);
    const [email, setEmail] = useState(user.email || '')
    const [object, setObject] = useState('')
    const [message, setMessage] = useState('')
    const [showMessage, setShowMessage] = useState({ show: false, message: '', error: false })
    const [valid, setValid] = useState(true)
    const navigate = useNavigate()

    const cancelMessage = () => {
        setEmail(user.email || '')
        setObject('')
        setMessage('')
        setValid(true)
        navigate('/')
    }

    async function sendMsg() {
        if (!email || !email.includes('@') || !object || !message) setValid(false)
        else {
            const setSupportMsg = await sendSupportMsg(email, object, message)
            if (setSupportMsg.ok) setShowMessage({ show: true, message: 'Your message has been sent. We’ll get back to you soon.', error: false })
            else setShowMessage({ show: true, message: 'Unable to send message. Please try again later.', error: true })
        }
    }
    return (<>
        <Popup visible={showMessage.show} id={styles.message}>
            {!showMessage.error && <img src={success} alt="success" style={{ width: '40px', height: "40px" }} />}
            <p style={{ textAlign: 'center', fontSize: '18px', marginTop: "20px" }}>{showMessage.message}</p>
            <Button
                onClick={() => { !showMessage.error ? navigate('/') : setShowMessage({ show: false, message: '', error: false }) }}
                style={{ marginTop: "40px", maxWidth: "350px" }}
                children={'OK'}
            />
        </Popup>
        <div style={{ marginTop: '20px' }} >
            <div className={styles.titleDiv}>
                <h1 className={styles.pageTitle}>Contact AT Support</h1>
                <p>Questions, comments, or suggestions? Simply fill in the form and we’ll be in touch shortly.</p>
            </div>
            <div className={styles.inputsContainer}>
                <h2>How can we help?</h2>
                <div className={styles.inputsDiv}>
                    <Input
                        type="email"
                        placeHolder='Email'
                        value={email}
                        style={(!email || !email.includes('@')) && !valid ? { border: '1px solid red' } : null}
                        onChange={(e) => { setEmail(e.target.value) }}
                        errText={!email && !valid ? 'This field is required' : !email.includes('@') && !valid ? 'Please enter a valid email address' : null}
                    />
                    <Input
                        type="text"
                        placeHolder='Subject'
                        style={!object && !valid ? { border: '1px solid red' } : null}
                        value={object}
                        onChange={(e) => { setObject(e.target.value) }}
                        errText={!object && !valid ? 'This field is required' : null}
                    />
                    <textarea placeholder="Message..."
                        style={!message && !valid ? { border: '1px solid red' } : null}
                        className={styles.textAreaSupp}
                        value={message}
                        onChange={(e) => { setMessage(e.target.value) }}
                    ></textarea>
                    {!message && !valid ? <p style={{ color: 'red', textAlign: 'left' }}>This field is required</p> : null}
                </div>
                <div className={styles.formActions}>
                    <Button children='Cancel' buttonType='secondary' onClick={cancelMessage} id={styles.cancelBtn} />
                    <Button children='Send Message' onClick={sendMsg} id={styles.sendBtn} />
                </div>
            </div>
        </div>
    </>
    )
})
